export default "/assets/images/CC-product-showcase-03.47cb0f80b3574bbc.jpg";